<template>
  <button @click="authFitbitRequest()" :disabled="loading || fitbit" class="inline-flex items-center place-content-center">
    <span v-if="fitbit">Connected to</span>
    <span v-else>Connect</span>
    <img src="@/assets/fitbit.svg" class="h-4 ml-2 p-px">
    <svg v-if="fitbit" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon" class="h-4 ml-2"><path fill-rule="evenodd" stroke="currentColor" stroke-width="1" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd"></path></svg>
  </button>
  <div v-if="syncing" class="flex flex-col items-center mt-8">
    <div class="">Syncing your sleep data...</div>
    <svg class="animate-spin h-16 w-16 m-4 text-teal-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  </div>
</template>

<script>
import { FitbitAuth } from '@/helpers/fitbit'
import { mapStores } from 'pinia'
import { useUserStore } from '@/stores/user'

// TODO: Extract out Fitbit auth into component.
// TODO: Check for internet connection.
export default {
  name: 'FitbitAuthenticator',
  components: {
  },
  emits: [
    'sync-complete',
  ],
  data() {
    return {
      codeVerifier: undefined,
      authCode: undefined,
      sleepData: [],
      loading: false,
      fitbit: false,
      syncing: false,
    }
  },
  beforeMount() {
    this.authFitbitResponse()
  },
  methods: {
    getCodeVerifier(size = 64) {
      const randomArray = crypto.getRandomValues(new Uint8Array(size));
      return Array.from(randomArray, (dec) => dec.toString(36)
        .padStart(2, '0')).join('');
    },
    getCodeChallenge(codeVerifier) {
      const codeVerifierArray = new TextEncoder().encode(codeVerifier);
      return crypto.subtle.digest('SHA-256', codeVerifierArray)
        .then((hash) => {
          const hashArray = new Uint8Array(hash);
          const hashBinaryString = String.fromCharCode(...hashArray);
          const b64Encoded = btoa(hashBinaryString);
          const b64UrlEncoded = b64Encoded.replaceAll('+','-')
              .replaceAll('/','_');
          // remove padding
          return b64UrlEncoded.replaceAll('=','');
        });
    },
    authFitbitRequest() {
      this.loading = true

      // Step 1: Generate PKCE Code Verifier, PKCE Code Challenge, and State.
      this.codeVerifier = this.getCodeVerifier()
      localStorage.setItem('codeVerifier', this.codeVerifier)
      var codeChallenge = ''
      this.getCodeChallenge(this.codeVerifier).then(cc => {
        codeChallenge = cc
        const startState = this.getCodeVerifier(12)
        console.log('codeVerifier:', this.codeVerifier)
        console.log('codeChallenge:', codeChallenge)
        console.log('startState:', startState)

        // Step 2: Display Authorization Page.
        // scope=activity+cardio_fitness+electrocardiogram+heartrate+irregular_rhythm_notifications+location+nutrition+oxygen_saturation+profile+respiratory_rate+settings+sleep+social+temperature+weight
        const redirectURL = 'https://www.fitbit.com/oauth2/authorize?response_type=code&client_id='+process.env.VUE_APP_FITBIT_CLIENT_ID+'&scope=sleep&code_challenge='+codeChallenge+'&code_challenge_method=S256&state='+startState
        window.location.replace(redirectURL);
      });
    },
    async authFitbitResponse() {
      const apiAuth = new FitbitAuth()
      this.loading = true
      this.fitbit = await apiAuth.isConnected()

      // If fitbit is already connected when the component is loaded, then we
      // start syncing immediately without verifying URL query params.
      if (this.fitbit) {
        return this.sync()
      }

      // Step 3: Handle the Redirect
      this.authCode = this.$route.query.code
      const returnState = this.$route.query.state

      if (!this.authCode || !returnState) {
        this.loading = false
        return
      }

      // Step 4: Get Tokens.
      // Request will contain clientID, authCode, and codeVerifier.
      // var startState = ''
      const codeVerifier = localStorage.getItem('codeVerifier')
      apiAuth.requestAccessToken(this.authCode, codeVerifier).then(data => {
        console.log('data:', data)
        // Clear the params once we're done here.
        this.$router.replace(this.$router.currentRoute.path)
        this.loading = false
        return apiAuth.isConnected()
      })
      .then(connected => {
        this.fitbit = connected
        return this.sync()
      })

      // if (startState !== returnState) {
      //   console.log('ERROR: States do not match')
      // }

      // Step 5: Check Scopes.
    },
    async sync() {
      this.syncing = true
      const data = await this.userStore.user.syncFitbit()
      this.syncing = false
      this.$emit('sync-complete')
      return data
    },
    authFitbitRevoke() {
      const apiAuth = new FitbitAuth()
      apiAuth.revokeTokens().then(response => {
        console("Revoked access token:", response)
      }).catch(error => {
        console("Revoke access token error:", error)
      })
    },
  },
  computed: {
    ...mapStores(useUserStore),
  },
}
</script>